import React from "react";

const containerCls = "min-h-screen bg-white text-slate-800";
const wrapCls = "max-w-3xl mx-auto px-6 py-12";
const h1Cls = "text-3xl sm:text-4xl font-bold text-slate-900 mb-2";
const effectiveCls = "text-sm text-slate-500 mb-8";
const h2Cls = "text-xl font-semibold text-slate-900 mt-8 mb-3";
const pCls = "text-base leading-relaxed mb-4";
const ulCls = "list-disc pl-6 space-y-1 mb-4 text-base leading-relaxed";
const footerCls = "mt-16 pt-6 border-t border-slate-200 text-sm text-slate-500";

export default function PrivacyPolicy() {
  return (
    <div className={containerCls} data-testid="privacy-policy-page">
      <div className={wrapCls}>
        <h1 className={h1Cls}>PrepHacker-RN Privacy Policy</h1>
        <p className={effectiveCls}>Effective Date: July 22, 2026</p>

        <h2 className={h2Cls}>1. Introduction</h2>
        <p className={pCls}>
          PrepHacker-RN (&quot;PrepHacker&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) is an
          AI-powered nursing examination preparation platform developed by Touch Universe Creative Services
          Pvt. Ltd. This Privacy Policy explains how we collect, use, store, and protect your information
          when you use our website, mobile application, WhatsApp services, email communications, and related
          services.
        </p>
        <p className={pCls}>By using PrepHacker-RN, you agree to this Privacy Policy.</p>

        <h2 className={h2Cls}>2. Information We Collect</h2>

        <h3 className="font-semibold text-slate-800 mt-4 mb-2">Personal Information</h3>
        <p className={pCls}>We may collect:</p>
        <ul className={ulCls}>
          <li>First Name</li>
          <li>Last Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Address</li>
          <li>Country</li>
          <li>State</li>
          <li>City</li>
          <li>Postal/PIN Code</li>
        </ul>

        <h3 className="font-semibold text-slate-800 mt-4 mb-2">Educational Information</h3>
        <p className={pCls}>We collect:</p>
        <ul className={ulCls}>
          <li>Target Examination (NCLEX, DHA, HAAD, MOH, DOH, Prometric, etc.)</li>
          <li>Subscription Examination</li>
          <li>Examination Year</li>
        </ul>

        <h3 className="font-semibold text-slate-800 mt-4 mb-2">Account Information</h3>
        <p className={pCls}>We maintain:</p>
        <ul className={ulCls}>
          <li>User ID</li>
          <li>User Code</li>
          <li>Join Date</li>
          <li>Last Login</li>
          <li>Subscription Status</li>
        </ul>

        <h3 className="font-semibold text-slate-800 mt-4 mb-2">Learning Analytics</h3>
        <p className={pCls}>To improve your learning experience, we collect:</p>
        <ul className={ulCls}>
          <li>Practice question attempts</li>
          <li>Mock test performance</li>
          <li>Scores</li>
          <li>Accuracy</li>
          <li>Time spent</li>
          <li>Subject-wise performance</li>
          <li>Bloom&apos;s Taxonomy performance</li>
          <li>Readiness metrics</li>
        </ul>

        <h3 className="font-semibold text-slate-800 mt-4 mb-2">AI &amp; Communication Data</h3>
        <p className={pCls}>When you communicate with PrepHacker-RN through:</p>
        <ul className={ulCls}>
          <li>WhatsApp</li>
          <li>Email</li>
          <li>In-app chat</li>
        </ul>
        <p className={pCls}>
          we may store conversation history to provide support, improve our AI assistant, and maintain
          service quality.
        </p>

        <h2 className={h2Cls}>3. How We Use Your Information</h2>
        <p className={pCls}>We use your information to:</p>
        <ul className={ulCls}>
          <li>Create and manage your account</li>
          <li>Personalize your learning experience</li>
          <li>Provide AI-assisted learning recommendations</li>
          <li>Calculate readiness and progress metrics</li>
          <li>Deliver customer support</li>
          <li>Send important service updates</li>
          <li>Process subscriptions</li>
          <li>Improve our platform</li>
          <li>Detect misuse and maintain security</li>
        </ul>

        <h2 className={h2Cls}>4. AI Services</h2>
        <p className={pCls}>
          PrepHacker-RN uses Artificial Intelligence to provide educational assistance, customer support,
          and personalized recommendations.
        </p>
        <p className={pCls}>
          AI-generated responses are intended to assist learning and should not replace professional nursing
          education or official examination guidelines.
        </p>

        <h2 className={h2Cls}>5. WhatsApp &amp; Email Communications</h2>
        <p className={pCls}>With your consent, we may send:</p>
        <ul className={ulCls}>
          <li>Study reminders</li>
          <li>Trial reminders</li>
          <li>Subscription notifications</li>
          <li>Product updates</li>
          <li>Customer support messages</li>
        </ul>
        <p className={pCls}>You may opt out of promotional communications at any time.</p>

        <h2 className={h2Cls}>6. Data Sharing</h2>
        <p className={pCls}>We do not sell your personal information.</p>
        <p className={pCls}>We may share limited information with trusted service providers including:</p>
        <ul className={ulCls}>
          <li>Cloud hosting providers</li>
          <li>Payment processors</li>
          <li>Email delivery providers</li>
          <li>WhatsApp Business Platform</li>
          <li>Analytics providers</li>
        </ul>
        <p className={pCls}>only to operate our services.</p>

        <h2 className={h2Cls}>7. Data Security</h2>
        <p className={pCls}>
          We implement reasonable administrative, technical, and organizational safeguards to protect your
          information against unauthorized access, disclosure, alteration, or destruction.
        </p>

        <h2 className={h2Cls}>8. Data Retention</h2>
        <p className={pCls}>
          We retain your information while your account remains active or as necessary to provide our
          services and comply with legal obligations.
        </p>

        <h2 className={h2Cls}>9. Your Rights</h2>
        <p className={pCls}>You may request to:</p>
        <ul className={ulCls}>
          <li>Access your personal information</li>
          <li>Correct inaccurate information</li>
          <li>Delete your account</li>
          <li>Withdraw marketing consent</li>
        </ul>
        <p className={pCls}>
          Requests may be sent to:{" "}
          <a href="mailto:hello@prephacker.com" className="text-orange-600 hover:underline">
            hello@prephacker.com
          </a>
        </p>

        <h2 className={h2Cls}>10. Children&apos;s Privacy</h2>
        <p className={pCls}>
          PrepHacker-RN is intended for users preparing for professional nursing examinations and is not
          directed toward children.
        </p>

        <h2 className={h2Cls}>11. Changes</h2>
        <p className={pCls}>
          We may update this Privacy Policy periodically. Continued use of the platform constitutes
          acceptance of the revised policy.
        </p>

        <div className={footerCls}>
          © PrepHacker-RN · A product of Touch Universe Creative Services Pvt. Ltd. · Contact:{" "}
          <a href="mailto:hello@prephacker.com" className="text-orange-600 hover:underline">
            hello@prephacker.com
          </a>
        </div>
      </div>
    </div>
  );
}
